export interface UserData {
  id: number,
  person_profile: {
    person: {
      username: string
      person_general: {
        full_name: string
      }
    }
  }
}

export enum RequesterProfile {
  SECRETARY = 'SECRETARY',
  PATIENT = 'PATIENT'
}

export interface CancelationScheduleModalProps {
  scheduleId: number
  requesterUsername: string
  requesterProfile: RequesterProfile
  onSuccessClose: () => void
}

export interface OptionData {
  id: number | string
  label: string
  code?: string
}

export interface CancelationScheduleParams {
  scheduleId: number
  requesterUsername: string
}

export interface UseCancelationSchedule {
  cancelationFields: {
    cancelationReason: string
    cancelationDetails: string
  }
  validateRequiredFields: () => boolean
  handleChangeReason: (data: OptionData) => void
  handleChangeDetails: (value: string) => void
  handleCancelSchedule: () => void
  isCancelationSuccess: boolean
  isCancelationLoading: boolean
  isCancelationError: boolean
}

export interface CancelationScheduleRequest {
  scheduleId: number
  requestedBy: string
  reasonCode: string
  details: string
}